import React from "react";
import { useNavigate } from "react-router-dom";
import AminiiNavbar from "../components/AminiiNavbar";
import AminiiFooter from "../components/AminiiFooter";

function AminiiAbout() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const userFirstName = localStorage.getItem("userFirstName") || "";

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#ffffff" }}>
      <AminiiNavbar
        isLoggedIn={!!userId}
        userFirstName={userFirstName}
        onLogout={() => {
          localStorage.clear();
          navigate("/login");
        }}
      />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
        <h1 style={{ fontFamily: '"Caslon Antique", "Cormorant Garamond", Georgia, serif', fontSize: "clamp(1.8rem, 5vw, 3rem)", letterSpacing: "0.15em", marginBottom: 16, color: "#1a1a1a" }}>
          A M I N I I
        </h1>
        <p style={{ fontFamily: '"Cormorant Garamond", Georgia, serif', fontSize: "1rem", letterSpacing: "0.2em", textTransform: "uppercase", color: "#d4af37", marginBottom: 32 }}>
          Luxury Designer Wear
        </p>
        <p style={{ fontFamily: "system-ui, sans-serif", fontSize: "0.95rem", color: "#555", maxWidth: 500, textAlign: "center", lineHeight: 1.7, marginBottom: 40 }}>
          Our story is coming soon. We are crafting something special for you.
        </p>
        <button
          className="amin-explore-btn"
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </div>
      <AminiiFooter />
    </div>
  );
}

export default AminiiAbout;
